
























import Vue from 'vue';
import ButtonActivate from '@/components/campaign/ButtonActivate.vue';
import ButtonPause from '@/components/campaign/ButtonPause.vue';
import ButtonEdit from '@/components/campaign/ButtonEdit.vue';
import ButtonDuplicate from '@/components/campaign/ButtonDuplicate.vue';
import ButtonCancel from '@/components/campaign/ButtonCancel.vue';
import ChipStatus from '@/components/campaign/ChipStatus.vue';
import { Campaign } from '@/models';
export default Vue.extend({
  components: {
    ButtonActivate, ButtonEdit, ButtonPause, ButtonDuplicate, ButtonCancel, ChipStatus,
  },
  props: [ 'campaign', 'isMobile'],
  computed: {
    platformIcon(): string {
      return (this.campaign as Campaign).platform === 'SMS' ? 'mdiCellphoneMessage' : 'mdiWhatsapp';
    },
  },
});
